<div class="ev-monitor min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <!-- Header -->
  <div class="animate-fade-in flex flex-col xl:flex-row xl:items-end justify-between mb-6 gap-5">
    <div>
      <div class="flex items-center gap-3 mb-2">
        <div
          class="w-11 h-11 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 text-slate-900 flex items-center justify-center shadow-[0_8px_20px_-6px_rgba(251,191,36,0.55)]">
          <span class="material-icons">ev_station</span>
        </div>
        <div>
          <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">มอนิเตอร์สถานี EV</h1>
          <p class="text-slate-500 dark:text-slate-400 mt-0.5 font-medium">สถานะช่องจอดและหัวชาร์จแบบเรียลไทม์</p>
        </div>
      </div>
      <span *ngIf="siteState.selectedSite()?.name"
        class="inline-flex items-center gap-1.5 mt-2 px-3 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold border border-amber-100/80 dark:border-amber-800/50">
        <span class="material-icons text-[14px]">local_parking</span>{{ siteState.selectedSite()?.name }}
      </span>
    </div>

    <div class="flex flex-wrap items-center gap-3">
      <div *ngIf="lastFetchedAt()"
        class="inline-flex items-center gap-2 px-3 py-2 rounded-2xl bg-white/90 dark:bg-slate-800/90 border border-slate-100 dark:border-slate-700 text-xs text-slate-500">
        <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
        อัปเดต {{ lastFetchedAt() | date:'dd/MM/yyyy HH:mm:ss' }}
      </div>

      <label
        class="flex items-center gap-2 px-3 h-[46px] bg-white/95 dark:bg-slate-800/95 rounded-2xl border border-slate-100/50 dark:border-slate-700 cursor-pointer select-none shadow-sm"
        title="เปิดเพื่อดึงข้อมูลอัตโนมัติทุก 1 นาที">
        <input type="checkbox" [(ngModel)]="enableLiveRefresh" (change)="onLiveRefreshToggle()"
          class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400 cursor-pointer" />
        <span class="text-sm font-bold text-slate-600 dark:text-slate-300 whitespace-nowrap">Live (1 นาที)</span>
        <span *ngIf="enableLiveRefresh"
          class="inline-flex items-center gap-1 px-2 py-0.5 rounded-lg bg-amber-50 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 text-xs font-black tabular-nums border border-amber-200/60 dark:border-amber-800/50">
          <span class="material-icons text-[14px]">timer</span>
          {{ liveCountdownLabel }}
        </span>
      </label>

      <button type="button" (click)="onRefresh()" title="รีเฟรชข้อมูล"
        class="px-4 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-600 dark:text-slate-300 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:border-amber-200 hover:shadow-md transition-all flex items-center justify-center gap-2 cursor-pointer font-bold">
        <span class="material-icons text-[20px]" [class.animate-spin]="isLoading()">refresh</span>
        รีเฟรช
      </button>
    </div>
  </div>

  <!-- Summary strip -->
  <div *ngIf="selectedSiteId && cards().length > 0"
    class="animate-fade-in mb-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
    <div class="ev-stat">
      <span class="ev-stat__label">ช่องทั้งหมด</span>
      <span class="ev-stat__value">{{ cards().length }}</span>
    </div>
    <div class="ev-stat ev-stat--occupied">
      <span class="ev-stat__label">ช่องเต็ม</span>
      <span class="ev-stat__value">{{ occupiedCount }}</span>
    </div>
    <div class="ev-stat ev-stat--empty">
      <span class="ev-stat__label">ช่องว่าง</span>
      <span class="ev-stat__value">{{ emptyCount }}</span>
    </div>
    <div class="ev-stat ev-stat--taken">
      <span class="ev-stat__label">กำลังชาร์จ</span>
      <span class="ev-stat__value">{{ chargerTakenCount }}</span>
    </div>
    <div class="ev-stat ev-stat--empty">
      <span class="ev-stat__label">ชาร์จสำเร็จ</span>
      <span class="ev-stat__value">{{ chargerCompletedCount }}</span>
    </div>
    <div class="ev-stat ev-stat--error">
      <span class="ev-stat__label">Offline</span>
      <span class="ev-stat__value">{{ chargerErrorCount }}</span>
    </div>
  </div>

  <!-- Legend -->
  <div *ngIf="selectedSiteId && cards().length > 0"
    class="animate-fade-in mb-5 flex flex-wrap items-center gap-2 text-[11px] font-bold">
    <span class="text-slate-400 uppercase tracking-wider mr-1">หัวชาร์จ</span>
    <span class="ev-legend ev-legend--idle">idle · ยังไม่ชาร์จ</span>
    <span class="ev-legend ev-legend--taken">taken + charging · กำลังชาร์จ</span>
    <span class="ev-legend ev-legend--idle">error (−1) · ชาร์จสำเร็จ</span>
    <span class="ev-legend ev-legend--error">error (0x100202) · Offline</span>
  </div>

  <div class="relative min-h-[280px]">
    <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

    <div *ngIf="!selectedSiteId && !isLoading()"
      class="animate-fade-in rounded-[2rem] border border-dashed border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-slate-800/50 py-20 text-center text-slate-400">
      <span class="material-icons text-5xl mb-3 text-slate-300">info</span>
      <p class="font-bold text-base">กรุณาเลือกลานจาก Sidebar</p>
      <p class="text-xs mt-1 text-slate-400">เลือก site เพื่อดูสถานะช่องจอดและหัวชาร์จ</p>
    </div>

    <div *ngIf="selectedSiteId && !isLoading() && cards().length === 0"
      class="animate-fade-in rounded-[2rem] border border-dashed border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-slate-800/50 py-20 text-center text-slate-400">
      <span class="material-icons text-5xl mb-3 text-slate-300">ev_station</span>
      <p class="font-bold text-base">ไม่พบช่องจอดสถานี EV</p>
      <p class="text-xs mt-1 text-slate-400">ยังไม่มี gate ประเภท EV Station ในลานนี้</p>
    </div>

    <div *ngIf="selectedSiteId && cards().length > 0"
      class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5"
      [class.opacity-50]="isLoading()">
      <article *ngFor="let card of cards(); trackBy: trackByGateId"
        (click)="onCardClick(card)"
        class="ev-card animate-fade-in group bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700"
        [ngClass]="cardAccentClass(card)"
        [class.ev-card--clickable]="card.isFull"
        [class.ev-card--charging]="isActivelyCharging(card)">

        <div class="ev-card__accent"></div>
        <div *ngIf="isActivelyCharging(card)" class="ev-card__glow" aria-hidden="true"></div>

        <div class="ev-card__body">
          <!-- Top row -->
          <div class="flex items-start justify-between gap-3 mb-3">
            <div class="min-w-0">
              <h3 class="text-base font-black text-slate-800 dark:text-slate-100 tracking-tight truncate">
                {{ card.gateName || '—' }}
              </h3>
              <p class="text-[11px] font-semibold text-slate-400 mt-0.5 truncate" [title]="transactionLabel(card)">
                {{ transactionLabel(card) }}
              </p>
            </div>
            <div class="flex flex-col items-end gap-1.5 shrink-0">
              <div class="flex items-center gap-1.5">
                <button *ngIf="canCreateManualEntry(card)" type="button" title="ทำรายการเข้า"
                  (click)="openManualEntryModal(card, $event)"
                  class="w-8 h-8 rounded-xl inline-flex items-center justify-center border border-emerald-200 dark:border-emerald-800/60 bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 hover:bg-emerald-100 dark:hover:bg-emerald-900/40 hover:border-emerald-400 transition-all cursor-pointer shrink-0">
                  <span class="material-icons text-base">add</span>
                </button>
                <span class="ev-badge"
                  [class.ev-badge--full]="card.isFull"
                  [class.ev-badge--vacant]="!card.isFull">
                  {{ card.isFull ? 'เต็ม' : 'ว่าง' }}
                </span>
              </div>
              <span *ngIf="card.relayChargerStatus" class="ev-charger-pill"
                [ngClass]="relayChargerStatusClass(card)"
                [class.ev-charger-pill--charging]="isActivelyCharging(card)"
                [title]="card.relayChargerCode || ''">
                <span *ngIf="isActivelyCharging(card)" class="material-icons ev-charger-pill__bolt">bolt</span>
                <span *ngIf="isChargeCompleted(card)" class="material-icons text-[14px]">check_circle</span>
                <span *ngIf="!isActivelyCharging(card) && !isChargeCompleted(card)" class="ev-charger-pill__dot"
                  [class.ev-charger-pill__dot--pulse]="false"></span>
                {{ relayChargerStatusLabel(card) }}
              </span>
            </div>
          </div>

          <!-- Media -->
          <div class="ev-card__media mb-3"
            [class.ev-card__media--charging]="isActivelyCharging(card)">
            <img *ngIf="card.isFull && imageSrc(card) as src" [src]="src" [alt]="card.gateName" class="ev-card__img" />
            <div *ngIf="card.isFull && !imageSrc(card)" class="ev-card__placeholder">
              <span class="material-icons text-5xl text-slate-300 dark:text-slate-600">directions_car</span>
            </div>
            <div *ngIf="!card.isFull" class="ev-card__placeholder ev-card__placeholder--empty">
              <span class="material-icons text-4xl text-emerald-400/70 mb-1">check_circle_outline</span>
              <span class="text-xs font-bold text-slate-400">พร้อมรับรถ</span>
            </div>

            <!-- Charging electricity overlay -->
            <div *ngIf="isActivelyCharging(card)" class="ev-charge-fx" aria-hidden="true">
              <span class="ev-charge-fx__bolt ev-charge-fx__bolt--main material-icons">bolt</span>
              <span class="ev-charge-fx__bolt ev-charge-fx__bolt--a material-icons">bolt</span>
              <span class="ev-charge-fx__bolt ev-charge-fx__bolt--b material-icons">flash_on</span>
              <span class="ev-charge-fx__ring"></span>
            </div>

            <span *ngIf="card.isFull && chargingStatusLabel(card) as statusLabel"
              class="ev-card__media-chip"
              [ngClass]="chargingStatusClass(card)">
              {{ statusLabel }}
            </span>
          </div>

          <!-- Meta -->
          <div class="space-y-2.5">
            <div class="flex items-center gap-2">
              <span class="ev-meta-label">ทะเบียน</span>
              <div class="flex-1 min-w-0">
                <span *ngIf="card.isFull && card.licensePlate" class="ev-plate">{{ card.licensePlate }}</span>
                <span *ngIf="!card.isFull || !card.licensePlate" class="text-slate-400">—</span>
              </div>
              <button *ngIf="card.isFull" type="button" title="แก้ไขทะเบียน"
                (click)="openLicenseEditModal(card, $event)"
                class="w-8 h-8 rounded-xl inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-amber-400 hover:text-amber-500 hover:bg-amber-50/50 dark:hover:bg-amber-900/20 transition-all cursor-pointer shrink-0">
                <span class="material-icons text-base">edit</span>
              </button>
            </div>

            <div *ngIf="card.isFull" class="ev-meta-box flex items-start justify-between gap-2">
              <div class="min-w-0">
                <span class="ev-meta-label">เจ้าของ</span>
                <span class="ev-meta-value block"
                  [class.text-emerald-600]="card.activate || !!card.lineUid"
                  [class.dark:text-emerald-400]="card.activate || !!card.lineUid"
                  [class.text-slate-400]="!card.activate && !card.lineUid">
                  {{ ownerStatusLabel(card) }}
                </span>
                <span *ngIf="card.lineUid" class="block mt-0.5 text-[11px] font-semibold text-slate-500 dark:text-slate-400 break-all"
                  [title]="card.lineUid">
                  line_id: {{ card.lineUid }}
                </span>
              </div>
              <span class="material-icons text-lg shrink-0 mt-0.5"
                [class.text-emerald-500]="card.activate || !!card.lineUid"
                [class.text-slate-300]="!card.activate && !card.lineUid"
                [class.dark:text-slate-600]="!card.activate && !card.lineUid">
                {{ card.activate || card.lineUid ? 'person' : 'person_off' }}
              </span>
            </div>

            <div class="grid grid-cols-2 gap-2">
              <div class="ev-meta-box">
                <span class="ev-meta-label">เวลาเข้า</span>
                <span class="ev-meta-value">
                  {{ card.isFull && card.enterAt ? (card.enterAt | date:'dd/MM HH:mm') : '—' }}
                </span>
              </div>
              <div class="ev-meta-box">
                <span class="ev-meta-label">ระยะจอด</span>
                <span class="ev-meta-value truncate" [title]="card.dwellTimeText">
                  {{ card.isFull ? (card.dwellTimeText || '—') : '—' }}
                </span>
              </div>
            </div>

            <div *ngIf="card.relayChargerStatus"
              class="ev-meta-box ev-meta-box--charger flex items-center justify-between gap-2"
              [class.ev-meta-box--charging]="isActivelyCharging(card)">
              <div class="min-w-0">
                <span class="ev-meta-label">พลังงาน / ประเภท</span>
                <span class="ev-meta-value block truncate">
                  {{ card.relayChargedKwh || '0.00' }} kWh
                  <span *ngIf="card.relayChargerType" class="text-slate-400 font-semibold">· {{ card.relayChargerType }}</span>
                </span>
              </div>
              <span class="material-icons text-xl shrink-0"
                [class.ev-bolt-icon]="isActivelyCharging(card)"
                [class.text-slate-300]="!isActivelyCharging(card)"
                [class.dark:text-slate-600]="!isActivelyCharging(card)">bolt</span>
            </div>

            <div *ngIf="isTrueOffline(card) && card.relayVendorErrorCode"
              class="rounded-xl px-3 py-2 bg-rose-50 dark:bg-rose-950/30 border border-rose-100 dark:border-rose-900/40 text-[11px] font-bold text-rose-600 dark:text-rose-400 break-all">
              vendorErrorCode: {{ card.relayVendorErrorCode }}
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</div>

<app-modal-ev-charger-detail
  [isOpen]="isDetailModalOpen"
  [data]="selectedTransaction"
  (onClose)="closeDetailModal()">
</app-modal-ev-charger-detail>

<app-modal-ev-charger-license-edit
  [isOpen]="isLicenseEditModalOpen"
  [data]="selectedLicenseEditData"
  (onClose)="closeLicenseEditModal()"
  (onSave)="onLicenseSaved($event)">
</app-modal-ev-charger-license-edit>

<app-modal-ev-station-manual-entry
  [isOpen]="isManualEntryModalOpen"
  [gateId]="selectedManualEntryGate?.gateId || 0"
  [gateName]="selectedManualEntryGate?.gateName || ''"
  [userId]="userId"
  [menuId]="menuId"
  (onClose)="closeManualEntryModal()"
  (onSuccess)="onManualEntrySuccess()">
</app-modal-ev-station-manual-entry>
